(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('wikiTinymce', wikiTinymce);

    function wikiTinymce() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                ngModel: '='
            },
            template: '<textarea rows="50" ui-tinymce="tinymceOptions" ng-model="ngModel"></textarea>',
            link: function (scope) {
                scope.tinymceOptions = {
                    height: 500,
                    menubar: false,
                    plugins: 'link image table lists code paste autoresize',
                    toolbar: 'undo redo | formatselect | bold italic underline | bullist numlist | link image table | code',
                    content_css: 'content/css/wiki-content.css',
                    paste_data_images: false,
                    file_picker_types: 'image',
                    file_picker_callback: function (callback, value, meta) {
                        if (meta.filetype !== 'image') {
                            return;
                        }
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/jpeg,image/png,image/gif,image/webp');
                        input.onchange = function () {
                            var file = this.files[0];
                            if (!file) {
                                return;
                            }
                            var formData = new FormData();
                            formData.append('file', file);
                            var xhr = new XMLHttpRequest();
                            xhr.open('POST', 'api/wiki/images');
                            xhr.onload = function () {
                                if (xhr.status === 200) {
                                    var json = JSON.parse(xhr.responseText);
                                    callback(json.url, {alt: file.name});
                                }
                            };
                            xhr.onerror = function () {
                                window.alert('Falha no upload da imagem');
                            };
                            xhr.send(formData);
                        };
                        input.click();
                    }
                };
            }
        };
    }
})();
